// Module
var code = `<div class="list_filter">

    <form class="layout" data-bind="submit: submit">

        <div class="meta">

            <label for="search-filter-element" class="tw:sr-only" data-bind="text: translated('Search  ')"></label>
            <input class="item_filter" onkeydown="if (event.code === 'Enter') event.preventDefault()" id="search-filter-element" data-bind="textInput: itemTextFilter,
                       valueUpdate: 'input',
                       attr: {placeholder: translated('Search')},
                       css: {empty: !_.size(itemTextFilter())}">

            <a class="item_filter_clear" data-bind="click: _.partial(itemTextFilter, '')">×</a>

            <ul class="item_categories" data-bind="foreach: availableCategories,
                       style: {// subtract height of inputs and buttons
                               height: dialogHeight() - 70 + 'px'}">
                <li data-bind="css: {selected: \$parent.selectedCategory() == \$data,
                                 sub_category: !_.includes(\$parent.specialCategories, \$data.value)},
                           click: _.partial(\$parent.selectedCategory, \$data)">
                    <a data-bind="text: label"></a>
                </li>
            </ul>

            <div class="actions">

                <input type="button" data-bind="click: reset,
                              value: translated('Reset')">
                <input type="submit" class="confirm" data-bind="click: submit,
                              enable: allFiltersValid() && !submitInProgress(),
                              value: translated('Apply filter')">
            </div>

        </div>

        <div class="tw:border-shade-color-74 tw:border tw:mx-4"></div>
        <div class="listing" data-bind="style: {height: dialogHeight() + 'px'}">

            <div class="body" data-bind="style: !seed.inProgress() && _.includes([specialCategories.presets, specialCategories.favorites], selectedCategory()?.value) ?
                               {height: dialogHeight() - 40 + 'px',
                                marginBottom: '10px'} :
                               {height: dialogHeight() + 'px'}">
                <div class="loading_circle_container" data-bind="visible: seed.inProgress">
                    <div class="loading_circle"></div>
                </div>

                <!-- ko if: selectedCategory()?.value === specialCategories.modified && !seed.inProgress() -->
                <div class="modified">
                    <div class="no_modifications" data-bind="visible: _.keys(presetManager.definedFilters()).length < 1,
                                text: translated('All filters are on their default values.')">
                    </div>
                </div>
                <!-- /ko -->


                <!-- ko if: selectedCategory()?.value === specialCategories.presets && !seed.inProgress() -->
                <div class="presets" data-bind="with: presetManager, visible: !presetManager.active()">

                    <h3 data-bind="text: translated('Saved presets')" class="tw:text-lg"></h3>

                    <div class="preset_listing" data-bind="foreach: availablePresets">
                        <div class="preset_entry">
                            <a class="name tw:w-10/12" data-bind="text: _.template('<%= name %> (<%= _.keys(filters).length %>)')(\$data),
                                        click: \$parent.loadWithReset"></a>
                            <div class="preset_actions tw:w-2/12 tw:flex tw:justify-between">
                                <a class="icon_button icon_add only_icon_img" data-bind="click: \$parent.loadWithoutReset,
                                          visible: !inProgress()"></a>
                                <a class="icon_button icon_trash only_icon_img" data-bind="click: \$parent.remove,
                                          visible: !inProgress()"></a>
                                <span class="two_bubbles_loader_container" style="margin-inline-start: -40px;" data-bind="visible: inProgress">
                                <span class="two_bubbles_loader"></span>
                            </span>
                            </div>
                        </div>
                    </div>

                    <div class="no_presets" data-bind="visible: availablePresets().length < 1,
                                text: translated('No presets available.')">
                    </div>

                </div>
                <!-- /ko -->

                <!-- ko if: visibleFilters() && !seed.inProgress() -->
                <div class="filters" data-bind="template: { nodes: filterTemplateNodes, data: \$data },
                            css: seed() ? _.invert({true: seed().view_name}) : {}">
                </div>
                <!-- /ko -->

                <!-- ko if: selectedCategory()?.value === specialCategories.favorites && !seed.inProgress() -->
                <div class="favorites" data-bind="with: preferencesEditor">
                    <div class="editor" data-bind="visible: active">

                        <div data-bind="foreach: filterItems">
                            <div class="filter_item tw:flex tw:items-center" data-bind="css: {modified: isModified}">
                                <div class="tw:w-10/12 name" data-bind="css: {with_unit: \$data.unit}">
                                    <!-- ko text: label --><!-- /ko -->
                                    <!-- ko if: \$data.unit -->
                                    <span class="unit_label">
                                    (<span data-bind="text: \$data.unit"></span>)
                                </span>
                                    <!-- /ko -->
                                </div>
                                <a class="tw:w-2/12 icon_button icon_star only_icon_img" data-bind="click: toggleFavorite,
                                          css: {is_favorite: isFavorite(),
                                                not_favorite: !isFavorite(),
                                                has_conflict: isHidden()}"></a>
                                <a class="tw:w-2/12 icon_button icon_eye only_icon_img" data-bind="click: toggleHidden,
                                          css: {is_hidden: isHidden(),
                                                is_visible: !isHidden(),
                                                has_conflict: isFavorite()}"></a>
                            </div>
                        </div>

                    </div>
                </div>
                <!-- /ko -->

                ${"<" + "script"} type="text/html" id="filter-label-element">
                    <div class="tw:pt-1 tw:w-5/12 flexible_container filter_label">
                        <span class="two_bubbles_loader_container"
                              style="margin-inline-start: 30%"
                              data-bind="visible: \$data.inProgress
                                                  || \$data.filter.model.inProgress
                                                  || ((\$data.filter.seed.possible_values || {}).inProgress)">
                            <span class="two_bubbles_loader"></span>
                        </span>

                        <label class="flex_inside_main_box"
                               data-bind="text: \$data.label || \$data.filter.seed.label,
                                          css: {with_unit: \$data.filter.seed.unit}"></label>

                        <!-- ko if: \$data.filter.seed.unit -->
                        <span class="unit_label">
                            (<span data-bind="text: \$data.filter.seed.unit"></span>)
                        </span>
                        <!-- /ko -->

                        <span data-bind="css: {tooltip_box: \$data.help || (\$data.filter.seed.help && !_.isObject(\$data.filter.seed.help)),
                                           in_progress: \$data.inProgress
                                                        || \$data.filter.model.inProgress
                                                        || ((\$data.filter.seed.possible_values || {}).inProgress)}">

                            <!-- ko if: \$data.help || (\$data.filter.seed.help && !_.isObject(\$data.filter.seed.help)) -->
                            <span class="tooltip_icon">
                                <div class="tooltip_content"
                                     data-bind="text: _.isObject(\$data.filter.seed.help) ? \$data.help : \$data.filter.seed.help"></div>
                            </span>
                                <!-- /ko -->
                        </span>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-input-element">
                    <input data-bind="textInput: \$data.filter.value,
                                      disable: \$data.inProgress
                                                || \$data.filter.model.disable
                                                || ((\$data.filter.seed.possible_values || {}).inProgress),
                                      css: {'tw:w-7/12': !\$data.halfWidth,
                                            'tw:w-5/12': \$data.halfWidth}" />
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-number-input-element">
                    <input type="number"
                           data-bind="valueAsNumber: \$data.filter.model.value || \$data.filter.value,
                                  disable: \$data.inProgress
                                           || \$data.filter.model.disable
                                           || ((\$data.filter.seed.possible_values || {}).inProgress),
                                  attr: {min: \$data.min,
                                         max: \$data.max,
                                         step: \$data.step},
                                  css: {invalid_data: \$data.filter.model.value && \$data.filter.model.value.isInvalid,
                                        'tw:w-7/12': !\$data.halfWidth,
                                        'tw:w-5/12': \$data.halfWidth}" />
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-date-input-element">
                    <ko-calendar-popup class="tw:w-5/12"
                                       params="value: \$data.filter.model.value || \$data.filter.value,
                                               options: \$data.options,
                                               enabled: !(\$data.filter.model.disable && \$data.filter.model.disable()),
                                               class: 'tw:w-full',
                                               css: {invalid_data: \$data.filter.model.value && \$data.filter.model.value.isInvalid}"></ko-calendar-popup>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-select-element">
                    <select class="tw:w-7/12"
                            data-bind="value: \$data.value || \$data.filter.value,
                                       options: \$data.options || \$data.filter.model.possibleValues || \$data.filter.seed.possible_values,
                                       optionsValue: \$data.optionsValue || 'id',
                                       optionsText: \$data.optionsText || 'name',
                                       optionsCaption: \$data.optionsCaption === undefined &&
                                                       translated('All') ||
                                                       \$data.optionsCaption,
                                       disable: \$data.inProgress
                                                || \$data.filter.model.disable
                                                || ((\$data.filter.seed.possible_values || {}).inProgress)"></select>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-multiple-select-element">
                    <select class="tw:w-7/12"
                            multiple
                            data-bind="selectedOptions: \$data.value || \$data.filter.value,
                                   options: \$data.options || \$data.filter.model.possibleValues || \$data.filter.seed.possible_values,
                                   optionsValue: \$data.optionsValue || 'id',
                                   optionsText: \$data.optionsText || 'name',
                                   optionsCaption: \$data.optionsCaption === undefined &&
                                                   translated('All') ||
                                                   \$data.optionsCaption,
                                   disable: \$data.inProgress
                                            || \$data.filter.model.disable
                                            || ((\$data.filter.seed.possible_values || {}).inProgress)"></select>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-location-element">
                    <!-- ko component: {name: 'location-picker-popup',
                                        params: {className: 'tw:w-7/12',
                                                 initialized: \$data.filter.model.initialized,
                                                 preselectLocation: \$data.filter.model.preselectLocation,
                                                 cleanLocationsTrigger: \$data.filter.model.cleanLocationsTrigger,
                                                 unselectLocationTrigger: \$data.filter.model.cleanLocationsTrigger,
                                                 selectedLocation: \$data.filter.model.selectedLocation,
                                                 possibleLocations: \$data.filter.model.possibleLocations,
                                                 selectLocationTrigger: \$data.filter.model.selectLocationTrigger,
                                                 hidePopupTrigger: \$data.filter.model.hidePopupTrigger,
                                                 selectType: \$data.filter.model.selectType,
                                                 disabled: \$data.filter.model.disable && \$data.filter.model.disable()}} -->
                    <!-- /ko -->
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-cryotank-element">
                    <div class="tw:w-7/12">
                        <ko-cryotank-picker params="cryotankId: \$data.filter.model.cryotankId,
                                                    cryotankPath: \$data.filter.model.cryotankPath,
                                                    allowSelectAnyPath: true,
                                                    disable: \$data.filter.model.disable"></ko-cryotank-picker>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="filter-selectem-element">
                    <div class="tw:w-7/12">
                        <ko-selectem data-bind="css: {invalid_data: \$data.filter.value.isInvalid}"
                                     params="value: \$data.value,
                                         options: \$data.options || \$data.filter.seed.possible_values,
                                         labelKey: \$data.labelKey || 'name',
                                         metaKey: \$data.metaKey,
                                         groupKey: \$data.groupKey || null,
                                         groupOrder: \$data.groupOrder || null,
                                         groupLabels: \$data.groupLabels || null,
                                         selectType: \$data.selectType || 'single',
                                         displayStyle: \$data.displayStyle || 'inline',
                                         serializeKey: \$data.serializeKey || 'id',
                                         serialize: \$data.serialize || \$data.filter.value,
                                         deserialize: \$data.deserialize || \$data.filter.value,
                                         allowCustom: \$data.allowCustom,
                                         customValues: \$data.customValues,
                                         caption: \$data.caption === undefined ?
                                                  translated('All') :
                                                  \$data.caption,
                                         disabled: \$data.inProgress
                                                   || \$data.filter.model.disable
                                                   || ((\$data.filter.seed.possible_values || {}).inProgress)"></ko-selectem>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="input-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-input-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="number-input-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-number-input-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="date-input-filter">
                    <div class="filter_item"
                         data-bind="visible: true">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: {filter: \$data.filter}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-date-input-element',
                                           data: {filter: \$data.filter,
                                                  options: \$data.options}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="input-range-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.min_filter.isVisible || \$data.max_filter.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: {filter: \$data.min_filter}} -->
                        <!-- /ko -->
                        <div class="tw:flex tw:items-center
                                    tw:justify-between tw:w-7/12">
                            <!-- ko template: {name: 'filter-input-element',
                                               data: {filter: \$data.min_filter,
                                                      halfWidth: true}} -->
                            <!-- /ko -->
                            <span>–</span>
                            <!-- ko template: {name: 'filter-input-element',
                                               data: {filter: \$data.max_filter,
                                                      halfWidth: true}} -->
                            <!-- /ko -->
                        </div>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="number-input-range-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.min_filter.isVisible || \$data.max_filter.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: {filter: \$data.min_filter}} -->
                        <!-- /ko -->
                        <div class="tw:w-7/12 tw:flex tw:items-center tw:justify-between">
                            <!-- ko template: {name: 'filter-number-input-element',
                                               data: {filter: \$data.min_filter,
                                                      min: \$data.min,
                                                      max: \$data.max,
                                                      step: \$data.step,
                                                      halfWidth: true}} -->
                            <!-- /ko -->
                            <span>–</span>
                            <!-- ko template: {name: 'filter-number-input-element',
                                               data: {filter: \$data.max_filter,
                                                      min: \$data.min,
                                                      max: \$data.max,
                                                      step: \$data.step,
                                                      halfWidth: true}} -->
                            <!-- /ko -->
                        </div>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="date-input-range-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.min_filter.isVisible || \$data.max_filter.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: {filter: \$data.min_filter}} -->
                        <!-- /ko -->
                        <div class="tw:flex tw:items-center
                                    tw:justify-between tw:w-7/12">
                            <!-- ko template: {name: 'filter-date-input-element',
                                               data: {filter: \$data.min_filter,
                                                      halfWidth: true}} -->
                            <!-- /ko -->
                            <span>–</span>
                            <!-- ko template: {name: 'filter-date-input-element',
                                               data: {filter: \$data.max_filter,
                                                      halfWidth: true}} -->
                            <!-- /ko -->
                        </div>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="select-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-select-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="multiple-select-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-multiple-select-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="selectem-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-selectem-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="location-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-location-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="mutation-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} --><!-- /ko -->
                        <div class="tw:w-7/12 tw:flex tw:gap-x-2 tw:gap-y-0.5 tw:flex-wrap">
                            <!-- ko if: \$data.model.mutationGrades().length > 2 -->
                            <select class="tw:w-full"
                                    data-bind="value: \$data.model.joinMutationGrades,
                                               options: \$data.model.possibleValues().join_mutation,
                                               optionsValue: 'id',
                                               optionsText: 'name'"></select>
                            <!-- /ko -->

                            <!-- ko foreach: \$data.model.mutationGrades() -->
                            <select class="tw:w-8/12"
                                    data-bind="value: \$data.mutationValue,
                                           options: \$parent.model.possibleMutations,
                                           optionsValue: 'id',
                                           optionsText: 'name',
                                           optionsCaption: translated('All'),
                                           disable: \$parent.model.inProgress ||
                                                    \$parent.model.disable ||
                                                    (\$parent.seed.possible_values || {}).inProgress"></select>
                            <select class="tw:grow"
                                    data-bind="value: \$data.gradeValue,
                                           options: \$parent.model.possibleGrades(\$data.mutationValue()),
                                           optionsValue: 'id',
                                           optionsText: 'name',
                                           optionsCaption: translated('All'),
                                           disable: \$parent.model.inProgress ||
                                                    \$parent.model.disable ||
                                                    (\$parent.seed.possible_values || {}).inProgress"></select>
                            <!-- /ko -->
                        </div>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="user-group-filter">
                    <div class="filter_item column_wise"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <h2 class="tw:mt-2">
                            <!-- ko text: translated('Select users') --><!-- /ko -->
                            (<!-- ko text: model.selectedUserIds().length --><!-- /ko -->)
                        </h2>
                        <div class="tw:border tw:border-shade-color-82 tw:bg-basic-color-white">
                            <div class="tw:flex tw:items-center tw:m-2">
                                <label class="tw:w-4/12" data-bind="text: translated('Group')"></label>
                                <ko-selectem class="tw:w-8/12"
                                             params="groupKey: null,
                                                     labelKey: 'name',
                                                     serializeKey: 'id',
                                                     selectType: 'multiple',
                                                     caption: translated('All'),
                                                     options: seed.possible_values,
                                                     serialize: model.selectedUserGroupIds"></ko-selectem>
                            </div>
                            <div class="tw:flex tw:items-center tw:m-2">
                                <label class="tw:w-4/12" data-bind="text: translated('Status')"></label>
                                <select class="tw:w-8/12"
                                        data-bind="value: model.selectedUserStatus,
                                                   optionsText: 'name',
                                                   optionsValue: 'id',
                                                   options: [{id: 'all', name: translated('All')},
                                                             {id: 'active', name: translated('Active')},
                                                             {id: 'inactive', name: translated('Inactive')}]"></select>
                            </div>
                            <div class="tw:flex tw:items-center tw:m-2">
                                <label class="tw:w-4/12" data-bind="text: translated('Select')"></label>
                                <div class="tw:w-8/12">
                                    <input type="button"
                                           class="tw:h-5!"
                                           data-bind="click: model.selectAllUsers, value: translated('All')">
                                    <input type="button"
                                           class="tw:h-5!"
                                           data-bind="click: model.selectNoUsers, value: translated('None2')">
                                    <input type="button"
                                           class="tw:h-5!"
                                           data-bind="click: model.invertUserSelection, value: translated('Invert')">
                                </div>
                            </div>
                            <!-- ko if: model.availableUsers().length -->
                                <div class="tw:h-48 tw:m-2 tw:overflow-scroll tw:border tw:border-shade-color-82"
                                     data-bind="css: {invalid_data: !model.valid()}">
                                    <ul class="tw:m-2">
                                        <!-- ko foreach: model.availableUsers -->
                                            <li>
                                                <label class="tw:block tw:hover:bg-shade-color-93 tw:p-1 tw:rounded-sm tw:cursor-pointer">
                                                    <input type="checkbox"
                                                           data-bind="checked: \$parent.model.selectedUserIds, checkedValue: \$data.userid">
                                                    <!-- ko text: fullname --><!-- /ko -->
                                                </label>
                                            </li>
                                        <!-- /ko -->
                                    </ul>
                                </div>
                            <!-- /ko -->
                        </div>
                    </div>
                ${"<" + "/script"}>

                ${"<" + "script"} type="text/html" id="cryotank-filter">
                    <div class="filter_item"
                         data-bind="visible: \$data.filter ? \$data.filter.isVisible : \$data.isVisible">
                        <!-- ko template: {name: 'filter-label-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                        <!-- ko template: {name: 'filter-cryotank-element',
                                           data: \$data.filter ? \$data : {filter: \$data}} -->
                        <!-- /ko -->
                    </div>
                ${"<" + "/script"}>
            </div>

            <!-- ko if: selectedCategory()?.value === specialCategories.presets && !seed.inProgress() -->
            <div class="presets" data-bind="with: presetManager">
                <div class="actions" data-bind="ifnot: active">
                    <input type="button" data-bind="value: translated('Create new preset'),
                                  click: _.partial(active, true)">
                </div>
                <div class="actions" data-bind="if: active">
                    <input maxlength="128" data-bind="textInput: newPresetName,
                                      enable: !inProgress(),
                                      css: {invalid_data: newPresetName() && newPresetName.isInvalid},
                                      attr: {placeholder: translated('Preset name')}">
                    <input type="button" data-bind="value: translated('Save selection as preset'),
                                  enable: !inProgress() && newPresetName.isValid() && _.keys(definedFilters()).length > 0,
                                  click: save">
                    <span class="two_bubbles_loader_container" data-bind="visible: inProgress">
                    <span class="two_bubbles_loader"></span>
                </span>
                </div>
            </div>
            <!-- /ko -->

            <!-- ko if: selectedCategory()?.value === specialCategories.favorites && !seed.inProgress() -->
            <div class="favorites" data-bind="with: preferencesEditor">
                <div class="actions">
                    <input type="button" data-bind="value: translated('Edit favorites'),
                                  click: _.partial(active, true),
                                  enable: !inProgress(),
                                  visible: !active()">
                    <input type="button" data-bind="value: translated('Cancel'),
                                  click: _.partial(active, false),
                                  enable: !inProgress(),
                                  visible: active()">
                    <input type="button" data-bind="value: translated('Save favorites'),
                                  click: save,
                                  enable: !inProgress(),
                                  visible: active()">
                    <span class="two_bubbles_loader_container" data-bind="visible: inProgress">
                    <span class="two_bubbles_loader"></span>
                </span>
                </div>
            </div>
            <!-- /ko -->
        </div>

    </form>

</div>
`;
// Exports
export default code;